module.exports = __webpack_public_path__ + "img/um.be0d3dd8.svg";